// extracted by mini-css-extract-plugin
export default {"chat":"messenger_chat__wJWOT"};